import { defineComponent, computed, toRefs } from '@vue/composition-api';
import dayjs from 'dayjs';
const RelativeTime = defineComponent({
    name: 'RelativeTime',
    props: {
        time: {
            type: String,
            default: '',
        },
        noTooltip: {
            type: Boolean,
            default: false,
        },
        turnOver: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const { time } = toRefs(props);
        const relativeTime = computed(() => dayjs(time.value).fromNow());
        const formatTime = computed(() => dayjs(time.value).format('YYYY-MM-DD HH:mm:ss'));
        const displayTime = computed(() => props.turnOver ? formatTime.value : relativeTime.value);
        const tooltipContent = computed(() => props.turnOver ? relativeTime.value : formatTime.value);
        return {
            relativeTime,
            formatTime,
            displayTime,
            tooltipContent,
        };
    },
    render() {
        if (this.noTooltip) {
            return <span>{this.displayTime}</span>;
        }
        // @ts-ignore
        if (Object.keys(window.vue?.options?.components).includes('TTooltip')) {
            return (<t-tooltip content={this.tooltipContent}>
        {this.displayTime}
      </t-tooltip>);
        }
        return (<a-tooltip title={this.tooltipContent}>
        {this.displayTime}
      </a-tooltip>);
    },
});
export default RelativeTime;
